import { useState, useRef, useEffect } from "react";

export const usePopup = () => {
  const [state, setState] = useState({
    isOpenAvatar: false,
    isOpenBell: false,
  });
  const avatarRef = useRef<HTMLDivElement>(null);
  const bellRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      // Check if click is inside a portal/modal (check for backdrop or modal elements)
      const isInsideModal =
        (target as Element).closest('[data-modal="true"]') !== null;

      if (isInsideModal) {
        // Don't close popups if clicking inside a modal
        return;
      }

      // Check if click is outside both popups
      const isOutsideAvatar =
        avatarRef.current && !avatarRef.current.contains(target);
      const isOutsideBell =
        bellRef.current && !bellRef.current.contains(target);

      if (isOutsideAvatar || isOutsideBell) {
        // Close all popups
        setState({
          isOpenAvatar: false,
          isOpenBell: false,
        });
      }
    };

    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Toggle functions
  const toggleAvatarPopup = () => {
    setState((prevState) => ({
      isOpenAvatar: !prevState.isOpenAvatar,
      isOpenBell: false, // Close bell popup when avatar is toggled
    }));
  };

  const toggleBellPopup = () => {
    setState((prevState) => ({
      isOpenAvatar: false, // Close avatar popup when bell is toggled
      isOpenBell: !prevState.isOpenBell,
    }));
  };

  return {
    state,
    avatarRef,
    bellRef,
    toggleAvatarPopup,
    toggleBellPopup,
  };
};
